import { html, LitElement } from "lit";
import { customElement } from 'lit/decorators.js';
import style from './usos-footer.scss';

/**
 * Footer container. Provides accessibility role and styling.
 */

@customElement('usos-footer')
export class UsosFooter extends LitElement {
    static override styles = style;

    override render() {
        return html`
            <div id="footer" role="contentinfo">
                <slot></slot>
            </div>
        `;
    }

}

declare global {
    interface HTMLElementTagNameMap {
        'usos-footer': UsosFooter
    }
}
